/*eslint-disable no-unused-vars*/
import React from 'react';
import ReactDOM from 'react-dom';
import { Ai2htmlAnimation, ArtboardsAnimation } from './App';
/*eslint-enable no-unused-vars*/
import './index.css';

ReactDOM.render(<Ai2htmlAnimation />, document.getElementById('ai2html-canvas'));
ReactDOM.render(<ArtboardsAnimation />, document.getElementById('artboards-canvas'));



// WEBPACK FOOTER //
// ./src/index.js